import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getAllSftpServerMasters, deleteSftpServerMaster } from '../services/api';
import { toast } from 'react-toastify';
import './Masters.css';

const SftpServerMasters = () => {
  const [servers, setServers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({});

  useEffect(() => {
    fetchServers();
  }, []);

  const fetchServers = async (page = 1) => {
    try {
      setLoading(true);
      const response = await getAllSftpServerMasters(page, 100);
      setServers(response.data);
      setPagination(response.pagination);
    } catch (error) {
      toast.error(error.message || 'Failed to fetch SFTP servers');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (serverId, serverName) => {
    if (window.confirm(`Are you sure you want to delete SFTP server "${serverName}"?`)) {
      try {
        await deleteSftpServerMaster(serverId);
        toast.success('SFTP server deleted successfully');
        fetchServers();
      } catch (error) {
        toast.error(error.message || 'Failed to delete SFTP server');
      }
    }
  };

  if (loading) {
    return <div className="loading">Loading SFTP servers...</div>;
  }

  return (
    <div className="masters-container">
      <div className="masters-header">
        <div>
          <h1>SFTP Server Masters</h1>
          <p className="subtitle">Manage reusable SFTP server configurations</p>
        </div>
        <Link to="/sftp-servers/new" className="btn btn-primary">
          + Create SFTP Server
        </Link>
      </div>

      {servers.length === 0 ? (
        <div className="empty-state">
          <h3>No SFTP Servers Found</h3>
          <p>Create your first SFTP server configuration to get started</p>
          <Link to="/sftp-servers/new" className="btn btn-primary">
            Create SFTP Server
          </Link>
        </div>
      ) : (
        <div className="masters-grid">
          {servers.map((server) => (
            <div key={server._id} className="master-card">
              <div className="card-header">
                <h3>{server.name}</h3>
                <span className={`badge ${server.isActive ? 'badge-success' : 'badge-danger'}`}>
                  {server.isActive ? 'Active' : 'Inactive'}
                </span>
              </div>
              
              <div className="card-body">
                {server.description && (
                  <p className="description">{server.description}</p>
                )}
                
                <div className="info-grid">
                  <div className="info-item">
                    <span className="label">Host:</span>
                    <span className="value">{server.host}</span>
                  </div>
                  
                  <div className="info-item">
                    <span className="label">Port:</span>
                    <span className="value">{server.port}</span>
                  </div>
                  
                  <div className="info-item">
                    <span className="label">Username:</span>
                    <span className="value">{server.username}</span>
                  </div>
                  
                  <div className="info-item">
                    <span className="label">Remote Path:</span>
                    <span className="value">{server.remotePath}</span>
                  </div>
                  
                  <div className="info-item">
                    <span className="label">Auth Method:</span>
                    <span className="value">
                      {server.privateKey ? 'Private Key' : 'Password'}
                    </span>
                  </div>
                  
                  <div className="info-item">
                    <span className="label">Priority:</span>
                    <span className="value">{server.priority}</span>
                  </div>
                </div>
              </div>
              
              <div className="card-footer">
                <Link to={`/sftp-servers/edit/${server._id}`} className="btn btn-sm btn-outline">
                  Edit
                </Link>
                <button
                  onClick={() => handleDelete(server._id, server.name)}
                  className="btn btn-sm btn-danger"
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SftpServerMasters;